<template>
  <div>
    <topHeaderNav />
    <!--侧边栏收缩按钮隐藏-->
    <!-- <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->
    <!-- <breadcrumb class="breadcrumb-container" /> -->
    <!-- <div class="navbar">
      <div class="left-logo">
        <img :src="logo" alt @click="toHome">
      </div>
      <div class="center-menu">
        <div>
          <router-link to="/">
            首页
          </router-link>
        </div>
        <div>
          <el-dropdown trigger="click">
            <div>
              <span>账户设置</span>
              <svg-icon class="svg-icon" icon-class="down" />
            </div>

            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <router-link to="/">
                <el-dropdown-item>
                  首页
                </el-dropdown-item>
              </router-link>
              <el-dropdown-item divided @click.native="logout">
                <span style="display:block;">退出登陆</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-dropdown trigger="click">
            <div>
              <span>评价</span>
              <svg-icon class="svg-icon" icon-class="down" />
            </div>

            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <router-link to="/">
                <el-dropdown-item>
                  首页
                </el-dropdown-item>
              </router-link>
              <el-dropdown-item divided @click.native="logout">
                <span style="display:block;">退出登陆</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="right-menu">
        <el-input v-model="input3" placeholder="请输入内容">
          <el-button slot="append">搜索</el-button>
        </el-input>
        <el-button class="right-cart" @click="toShoppingCar">
          <svg-icon class="svg-icon" icon-class="cart" />
          购物车
          <div class="cart-num">1</div>
        </el-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import topHeaderNav from '@/components/topHeaderNav.vue'
import { getIndexShopDecoration } from '@/api/home'
import logoimg from '@/assets/images/logoimg.png'

export default {
  components: {
    topHeaderNav
  },
  data() {
    return {
      input3: '',
      routerList: [], // 用户中心左侧显示的列表
      logo: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  created() {
    // const i = localStorage.getItem('userInfo')
    // this.logo = (i && JSON.parse(i).flogoImagePath) ? JSON.parse(i).flogoImagePath : logoimg
    const id = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).funitID : ''
    // getIndexShopDecoration({ modelID: 1, fDemandUnitId: id }).then((res) => {
    //   this.logo = res.malllogo.length ? (res.malllogo[0].FImagePath ? res.malllogo[0].FImagePath : logoimg) : logoimg
    // })
    //   .catch(() => {
    //     this.logo = logoimg
    //   })
    // this.routerList = this.$router.options.routes.filter(item => item.showHome)
  },
  methods: {
    toShoppingCar() {
      this.$router.push({
        path: '/shop'
      })
    },
    toHome() {
      this.$router.push({
        path: '/'
      })
    },
    // toggleSideBar() {
    //   this.$store.dispatch('app/toggleSideBar')
    // },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #EC212D;
  color: #fff;
}
/* 顶部导航栏CSS */
.topbar {
  height: 40px;
  background-color: #F4F4F4;
  padding: 0 75px;
}
.topbar ul{
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}
.topbar .nav,
.topbar .loginNav {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 10px;
}
.topbar .welcomeText{
  font-size: 14px;
  color: #666666;
  font-family: SimSun;
  line-height: 40px;
}
.topbar .loginNav li
.topbar .nav li {
  float: left;
  height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color:#EC212D;
}
.topbar .loginNav span,
.topbar .loginNav li{
  color:#333;
  cursor: pointer;
  font-size: 14px;
}
.topbar .nav li:nth-child(1)::before{
  content: none;
}
.topbar .nav li:after,
.topbar .loginNav li::after {
  content: "|";
  color: #ccc;
  width: 2px;
  height: 5px;
  margin: 0 10px;
}
.topbar .nav li:last-child::after,
.topbar .loginNav li:last-child::after {
  content: none;
}
.topbar .nav ul .notLogin {
  font-size: 14px;
  font-family: SimSun;
  color: #EC212D;
}
/* 顶部导航栏CSS END */
.navbar {
  height: 80px;
  overflow: hidden;
  position: relative;
  line-height: 80px;
  background: #FFF;
  color:#333;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  display: flex;
  justify-content: space-between;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  .breadcrumb-container {
    float: left;
  }
  .left-logo{
    width: 246px;
    margin-left: 50px;
    display: flex;
    align-items: center;
    img{
      max-height: 80px;
      max-width: 246px;
    }
  }
  .center-menu {
    display: flex;
    cursor: pointer;
    width: 294px;
    justify-content: space-between;
    align-items: center;
    .svg-icon{
      margin-left: 5px;
    }

  }
  .right-menu {
    height: 100%;
    line-height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &:focus {
      outline: none;
    }
    .el-input{
      width: 223px;
      height: 38px;
      margin-right: 20px;
    }
    .right-cart{
      margin-right: 80px;
      position: relative;
      .cart-num{
        position: absolute;
        right: -0;
        top: -10px;
        width: 30px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        color: #FFF;
        background: #FD6B09;
        border-radius: 10px 10px 10px 0px;
      }
    }
    .el-button:hover{
      border: 1px solid #EC212D;
      background: none;
      color: #333;
    }
    .el-input-group__append{
      background-color: #CDCDCD;
      color:#333;
      font-size: 16px;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      color: #fff;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 32px;
          height: 28px;
          border-radius: 10px;
          display: inline-block;
          vertical-align: middle;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 18px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
